import React, { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ruta } from "../utils.js";
import styled from "styled-components";
import back from "../assets/project-icons/Vector.svg";
import github from "../assets/project-icons/Vector-1.svg";
import demo from "../assets/project-icons/Vector-2.svg";
const ProjectC = styled.section`
  width: 100%;
  height: 100vh;

  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: #fff;

  @media (max-width: 450px) {
    .linkData {
      position: fixed;
      z-index: 11;
      bottom: 10%;
      right: 10%;
      width: 55px;
      height: 55px;

      a {
      }

      background-color: #fff;
    }
    .container {
      display: flex;
      width: 80%;
      flex-direction: column;
      margin-top:308px;
      h2 {
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 27.8px;
        line-height: 23px;
        color: #fff;
        margin: 0;
      }

      a {
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 18.8px;
        line-height: 23px;
        /* or 120% */

        color: #fff;

        letter-spacing: 0.282191px;
      }
      p {
        width: 100%;

        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 18.8px;
        line-height: 23px;
        /* or 120% */
        text-align: justify;
        color: #fff;

        letter-spacing: 0.282191px;
      }
      img {
        width: 100%;
      }
    }
    .ghost2 {
      width: 100%;

      height: 300px;
    }
  }
  @media (min-width: 450.1px) {
    .linkData {
      position: fixed;
      z-index: 11;
      bottom: 10%;
      right: 10%;
      width: 55px;
      height: 55px;

      a {
      }

      background-color: #fff;
    }
    .container {
      display: grid;
      width: 80%;
 
      flex-direction: column;

      .mark {
       
        display: grid;
        grid-auto-columns: 1fr 1fr;
        h2 {
          font-family: Nunito;
          font-style: normal;
          font-weight: normal;
          font-size: 27.8px;
          line-height: 23px;
          color: #fff;
          margin: 0;
        }
        a {
          font-family: Nunito;
          font-style: normal;
          font-weight: normal;
          font-size: 18.8px;
          line-height: 23px;
          /* or 120% */

          color: #fff;

          letter-spacing: 0.282191px;
        }

        p {
          font-family: Nunito;
          font-style: normal;
          font-weight: normal;
          font-size: 18.8px;
          line-height: 23px;
          /* or 120% */
          text-align: justify;
          color: #fff;
          justify-content: space-between;
          letter-spacing: 0.282191px;
        }
        width: 100%;
        justify-content: space-between;
        flex-wrap: wrap;

        h4,
        h2,
        p {
          color: #fff;
        }
        img {
          width: 200px;
        }
      }
    }
  }
`;

function Project() {
  const [data, setData] = useState(null);
  const [scrollS, setScrollS] = useState(false);
  let { id } = useParams();

  useEffect(() => {
    fetch(`${ruta}/projects/${id}`)
      .then((res) => res.json())
      .then((datas) => {
        setData(datas);
      });
  }, []);
  console.log(data);
  const scroll = useRef(null);
  const updateScroll = () => {
    const scrollLeft = scroll.current.scrollTop;
    console.log(scrollLeft);
    if (scrollLeft > scrollLeft - 314) {
      setScrollS(true);
    }
    if (scrollLeft + 10 <= 214) {
      setScrollS(false);
    }
    scroll.current.scrollTop = scrollLeft;
  };

  document.getElementsByTagName("");
  const Img = styled.div`
    @media (max-width: 450px) {
      width: 100%;
      background-size: cover;
      background-position: center;
      position: fixed;
      transition: all 1s ease;
      border-radius: 3px 3px 24px 24px;
      div {
        width: 100%;
        position: relative;
        transition: all 1s ease;
        .fondo {
          transition: all 1s ease;
          ${scrollS
            ? `width: 100%;
    height: 74px;
    border-radius: 3px 3px 31px 31px;
    /* min-height: 88px; */
    max-height: 308px;
    filter: brightness(0.6);
    object-fit: cover;
    position: fixed;`
            : `  width: 100%;
      height: 308px;
      border-radius: 3px 3px 24px 24px;
      min-height: 88px;
      max-height:308px;
      
      filter: brightness(0.7);`}
        }
        .back {
          transition: all 1s ease;
          ${scrollS
            ? `bottom: 1em;
    width: 35px;
    left: 2em;
    top: 1em;
    z-index: 11;
    position: absolute;`
            : `
width: 40px;
    left: 1em;
    height: 27px;
    top: 1em;
    z-index: 11;
    position: absolute;`}
          z-index:11;

          position: absolute;
          :hover {
            width: 41px;
            height: 41px;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.5);
          }
        }
        h1 {
          position: absolute;
          ${scrollS ? `    left: 21%;` : `bottom: 1em;left: 10%;`}

          text-transform: capitalize;

          width: auto;
          z-index: 11;
          font-family: Nunito;
          font-style: normal;
          font-weight: normal;
          font-size: 27.8px;
          line-height: 23px;
          color: #fff;
          display: flex;
          gap: 0.5em;
          align-items: center;
          a {
            width: 40px;
            height: 40px;

            img {
              width: 40px;
              height: 40px;
            }
          }
        }
      }
    }
    @media (min-width: 450.1px) {
      width: 100%;
      background-size: cover;
      background-position: center;

      border-radius: 3px 3px 24px 24px;
      div {
        width: 100%;
        position: relative;

        .fondo {
          transition: all 1s ease;
          width: 100%;
          height: 508px;
          border-radius: 3px 3px 24px 24px;
          min-height: 88px;
          max-height: 508px;

          filter: brightness(0.7);
          object-fit: cover;
        }
        .back {
          width: 40px;
          left: 1em;
          height: 27px;
          top: 1em;
          z-index: 11;
          position: absolute;
          z-index: 11;

          position: absolute;
          :hover {
            width: 41px;
            height: 41px;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.5);
          }
        }
        h1 {
          position: absolute;
          bottom: 1em;
          left: 10%;

          text-transform: capitalize;

          width: auto;
          z-index: 11;
          font-family: Nunito;
          font-style: normal;
          font-weight: normal;
          font-size: 80px;
          line-height: 23px;
          color: #fff;
          display: flex;
          gap: 0.5em;
          align-items: center;
          a {
            width: 90px;
            height: 90px;

            img {
              width: 90px;
              height: 90px;
            }
          }
        }
      }
    }
  `;
  return (
    <ProjectC id="scroll" ref={scroll} onScroll={updateScroll}>
      {data && (
        <>
         
          <Img heightScrolling={scrollS}>
            <div>
              {" "}
              <Link to="/projects">
                <img src={back} className="back" />
              </Link>
              <img className="fondo" src={data.thumbnail[0].url}></img>
              <h1>
                {data.name}{" "}
                <a rel="noreferrer" target="_blank" href={data.urlRepo}>
                  <img src={github} />
                </a>
                <a rel="noreferrer" target="_blank" href={data.urlDemo}>
                  <img src={demo} />
                </a>
              </h1>
            </div>
          </Img>
        
          
          <div className="container">
            <div className="mark">
              <ReactMarkdown>{data.body}</ReactMarkdown>
            </div>
          </div>
        </>
      )}
      <div className="ghost"></div>
    </ProjectC>
  );
}

export default Project;
